<template>
  <div>
    <!-- Modal Trigger -->
    <a class="btn pink waves-effect waves-light modal-trigger blue" href="#modal-filtros-logistica-dashboard"><i
        class="mdi mdi-filter"></i> FILTROS</a>

    <!-- Modal Structure -->
    <div id="modal-filtros-logistica-dashboard" class="modal">
      <div class="modal-content">
        <h4>FILTROS</h4>
        <form @submit="submit">
          <div class="row">
            <div class="col s12 m8 input-field">
              <label class="active" for="updated_at_start_date">Actualizado entre
              </label>
              <input v-model="filtros.updated_at_start_date" type="date" name="updated_at_start_date"
                id="updated_at_start_date" />
            </div>
            <div class="col s12 m4 input-field">
              <label class="active" for="updated_at_start_time">desde las</label>
              <input v-model="filtros.updated_at_start_time" type="time" step="1" id="updated_at_start_time"
                name="updated_at_start_time" />
            </div>
            <div class="col s12 m8 input-field">
              <label class="active" for="updated_at_end_date">Hasta</label>
              <input type="date" v-model="filtros.updated_at_end_date" id="updated_at_end_date"
                name="updated_at_end_date" />
            </div>
            <div class="col s12 m4 input-field">
              <label class="active" for="updated_at_end_time">a las</label>
              <input type="time" step="1" v-model="filtros.updated_at_end_time" id="updated_at_end_time"
                name="updated_at_end_time" />
            </div>
          </div>
          <div class="row">
            <div class="col s12 m4 input-field">
              <label class="active" for="ccmasterid">Trabajo</label>
              <input v-model="filtros.ccmasterid" type="text" id="ccmasterid" />
            </div>
            <div class="col s12 m4 input-field">
              <label class="active" for="dsforderid">Orden de DSF</label>
              <input type="text" v-model="filtros.dsforderid" id="dsforderid" />
            </div>
            <div class="col s12 m4 input-field">
              <label class="active" for="paqueteria_numero_rastreo"># de guía</label>
              <input type="text" list="num_list" v-model="filtros.paqueteria_numero_rastreo"
                id="paqueteria_numero_rastreo" />
              <datalist id="num_list">
                <option selected value="{no-nula}" />
              </datalist>
            </div>
          </div>
          <div class="row">
            <div class="col s12 input-field">
              <select v-model="filtros.shipviaid" class="browser-default" name="shipvia" id="shipvia">
                <option value="" selected>Todas las vías de envío</option>
                <option v-for="(shipvia, key) in shipvias" :key="key" :value="shipvia.syshipviaid">
                  {{ shipvia.syshipviaid }}-{{ shipvia.sydescription }}
                </option>
              </select>
            </div>
            <div class="col s12 input-field">
              <select @change="setValues" v-model="almacen_shipvia" class="browser-default" name="shipvia" id="shipvia">
                <option value="" selected>Todos los almacenes</option>
                <option v-for="(obj, key) in almacenes_shipvias" :key="key" :value="obj">
                  {{ key }}
                </option>
              </select>
            </div>
            <div class="col s12 input-field">
              <select v-model="filtros.vehiculo" class="browser-default" name="" id="">
                <option selected value="">Todos los Vehículos</option>
                <option v-for="(vehiculo, matricula) in vehiculos" :key="matricula"
                  :value="`${matricula} / ${vehiculo.modelo}`">
                  {{ matricula }} / {{ vehiculo.modelo }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <a href="#!" class="modal-close waves-effect waves-green btn-flat">Cerrar</a>
            <button type="submit" class="btn green">CONSULTAR</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import M from "materialize-css";
  import almacenes_shipvias from "../../../../recursos/almacenes_shipvias.json";
  export default {
    name: "modal-filtros",
    props: {},
    created() {
      setTimeout(() => {
        let modal = document.querySelector("#modal-filtros-logistica-dashboard");
        this.modal = M.Modal.init(modal, {});
      }, 0);
    },

    methods: {
      setValues() {
        let filtros = this.filtros,
          //shipvia = this.almacen_shipvia.shipvia || {},
          almacen = this.almacen_shipvia.almacen || {};
        //filtros.shipviaid = shipvia.syshipviaid;
        filtros.iclocid = almacen.iclocid;
      },
      submit(e) {
        e.preventDefault();
        this.consultar();
      },
      consultar() {
        let filtros = this.filtros;

        this.$emit("filtro", filtros);
        console.log(filtros);
        this.filtros.paqueteria_numero_rastreo =
          this.filtros.ccmasterid =
          this.filtros.dsforderid =
          undefined;
        this.modal.close();
      },
    },
    data() {
      let today = new Date(new Date().toDateString());
      let start_date = today,
        end_date = new Date(today.getTime() + 8.6399e7);
      end_date = new Date(end_date.setDate(end_date.getDate() - 1));
      let shipvias = window.localStorage.getItem("shipvias");
      shipvias = shipvias ? JSON.parse(shipvias) : {};
      let vehiculos = window.localStorage.getItem("vehiculos");
      vehiculos = vehiculos ? JSON.parse(vehiculos) : {};

      return {
        shipvias: shipvias,
        vehiculos: vehiculos,
        almacenes_shipvias: almacenes_shipvias,
        modal: undefined,
        almacen_shipvia: "",
        filtros: {
          shipviaid: "",
          vehiculo: "",
          updated_at_start_date: start_date.toISOString().split("T")[0],
          updated_at_start_time: start_date.toLocaleTimeString(),
          updated_at_end_date: end_date.toISOString().split("T")[0],
          updated_at_end_time: end_date.toLocaleTimeString(),
        },
      };
    },
  };
</script>
